var map = {
	"./decidim/avatar-multiuser.png": 73429,
	"./decidim/brands/facebook.svg": 55217,
	"./decidim/brands/google.svg": 47560,
	"./decidim/brands/twitter-x.svg": 5997,
	"./decidim/cc-badge.png": 27891,
	"./decidim/decidim-logo.svg": 17079,
	"./decidim/default-avatar.svg": 15259,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 28817,
	"./decidim/icons.svg": 27434,
	"./decidim/pattern.png": 77593,
	"./decidim/placeholder-card-g.svg": 39958,
	"./decidim/placeholder-card-l.svg": 91645,
	"./decidim/placeholder.jpg": 50108,
	"./decidim/remixicon.symbol.svg": 23246,
	"./decidim/vendor/social-share-button/douban.svg": 40497,
	"./decidim/vendor/social-share-button/email.svg": 41458,
	"./decidim/vendor/social-share-button/facebook.svg": 73690,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 61334,
	"./decidim/vendor/social-share-button/hacker_news.svg": 65666,
	"./decidim/vendor/social-share-button/linkedin.svg": 31936,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 38713,
	"./decidim/vendor/social-share-button/pinterest.svg": 73708,
	"./decidim/vendor/social-share-button/reddit.svg": 28230,
	"./decidim/vendor/social-share-button/telegram.svg": 90839,
	"./decidim/vendor/social-share-button/tumblr.svg": 21012,
	"./decidim/vendor/social-share-button/twitter.svg": 20487,
	"./decidim/vendor/social-share-button/vkontakte.svg": 37525,
	"./decidim/vendor/social-share-button/wechat.svg": 27576,
	"./decidim/vendor/social-share-button/whatsapp.svg": 60664,
	"./decidim/vendor/social-share-button/x.svg": 9362,
	"./decidim/vendor/social-share-button/xing.svg": 51190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65192;